{
  "actionSelectLabel": "Action",
  "createScheduleHelpContent": "Quick Scheduler est une fonctionnalité qui vous permet de créer un programme pour activer une pompe ou une vanne à une heure précise ou pour une durée spécifique.\n\nLes programmes peuvent être définis pour s'exécuter une fois ou pour se répéter certains jours de la semaine. Pour planifier une seule exécution, sélectionnez « Faire une fois » ; sinon, sélectionnez « Répéter ».\n\nVeuillez noter que cette fonctionnalité est destinée à être utilisée avec des pompes et des vannes qui peuvent être activées par FarmHQ. L'utilisation de cette fonctionnalité avec des pompes à arrêt uniquement ou d'autres types d'équipements peut avoir des conséquences imprévues.",
  "createScheduleHelpTitle": "À propos de Quick Scheduler",
  "dayPickerLabel": "Jour",
  "delayedShutdownTitle": "Arrêt retardé",
  "deviceSelectLabel": "Appareil",
  "deviceSelectPlaceholder": "(Choisir un appareil)",
  "durationHoursLabel": "Heures",
  "durationMinutesLabel": "Minutes",
  "errorMessages": {
    "DURATION_BELOW_MINIMUM": "La durée doit être supérieure à 0 minute.",
    "EXECUTION_TIME_IN_PAST": "Le temps d’exécution ne peut pas être dans le passé.",
    "NO_COMPATIBLE_DEVICES": "Aucun appareil compatible trouvé,",
    "NO_REPEATING_DAYS": "L'horaire doit se répéter au moins une journée.",
    "SCHEDULE_END_BEFORE_START": "La fin de l'horaire est avant le début.",
    "SCHEDULE_END_IN_PAST": "La fin du planning ne peut pas être dans le passé.",
    "SCHEDULE_START_IN_PAST": "Le début du planning ne peut pas être dans le passé.",
    "SHUTDOWN_IN_PAST": "L'arrêt doit être dans le futur"
  },
  "executeAt": "Exécuter à",
  "executeAtWithTimezone": "Exécuter à ({{timezone}})",
  "executionDay": "Jour de l'exécution",
  "frequencyLabel": "Fréquence",
  "linkToCreateSchedule": "Nouvel horaire",
  "linkToDelayedShutdown": "Arrêt retardé",
  "next": "Suivant",
  "nextDay": "Lendemain",
  "back": "Dos",
  "cancel": "Annuler",
  "noCompatibleDevices": "Aucun appareil compatible trouvé,",
  "quickSchedulerTitle": "Planificateur rapide",
  "repeatOnDays": "Répéter les jours",
  "scheduleEndLabel": "Fin du programme",
  "scheduleFrequencyTypes": {
    "doOnce": "À faire une fois",
    "repeat": "Répéter"
  },
  "schedulePumpingSession": "Planifier une séance de pompage",
  "scheduleStartLabel": "Début du programme",
  "shutdownPumpAt": "Arrêter la pompe à",
  "submit": "Soumettre",
  "timePickerLabel": "Temps",
  "turnOfThePumpForWithVal": "Éteignez la pompe pendant {{val}}",
  "turnOffThePumpAfter": "Éteignez la pompe après",
  "turnOnThePumpAt": "Allumez la pompe à",
  "turnOnThePumpAtWithTimezone": "Allumez la pompe à ({{timezone}})",
  "usageWarning": "Cette fonctionnalité est destinée à être utilisée avec des pompes et des vannes qui peuvent être activées par FarmHQ. L'utilisation de cette fonctionnalité avec des pompes à arrêt uniquement ou d'autres types d'équipements peut avoir des conséquences imprévues."
}
